import React from "react";

// ═══════════════════════════════════════════════════════════════════════════
// "Show all N things" ↔ "Show less" under a list on the plan page (CD42; 3 rows, 2 Nov).
// Lists show the first `OPC_PREVIEW` rows (or `shown` when the list decides
// its own collapsed rows, e.g. reports, CD43); the toggle only appears when
// there are more. Styles: `.opc-pv-more`.
// ═══════════════════════════════════════════════════════════════════════════

export const OPC_PREVIEW = 3;

const OpcShowMore = ({ total, shown = OPC_PREVIEW, open, onToggle, noun }) =>
  total > shown ? (
    <button
      type="button"
      className="opc-pv-more"
      aria-expanded={open}
      onClick={onToggle}
    >
      {open ? "Show less" : `Show all ${total} ${noun}`}
    </button>
  ) : null;

export default OpcShowMore;
